import { createApi, fakeBaseQuery } from '@reduxjs/toolkit/query/react'

export const apiSlice = createApi({
  reducerPath: 'api',
  baseQuery: fakeBaseQuery(),
  tagTypes: ["User", "Club", "Manager", "Admin", "Notifications", "Users", "Clubs", "ClubMembers"] as const,
  endpoints: () => ({}),
})